import { SignIn } from '@clerk/clerk-react';
import { motion } from 'framer-motion';

export function LoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 bg-bg-primary">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2 text-text-primary">FinDash</h1>
          <p className="text-text-secondary">AI-Powered Personal Finance</p>
        </div>

        <div className="flex justify-center">
          <SignIn
            appearance={{
              elements: {
                rootBox: 'w-full',
                card: 'bg-bg-secondary border border-border shadow-lg',
                headerTitle: 'text-text-primary',
                headerSubtitle: 'text-text-secondary',
                socialButtonsBlockButton:
                  'bg-bg-tertiary border-border text-text-primary hover:bg-bg-hover',
                socialButtonsBlockButtonText: 'text-text-primary',
                dividerLine: 'bg-border',
                dividerText: 'text-text-muted',
                formFieldLabel: 'text-text-secondary',
                formFieldInput:
                  'bg-bg-tertiary border-border text-text-primary focus:border-accent focus:ring-accent',
                formButtonPrimary: 'bg-accent hover:bg-accent-hover',
                footerActionLink: 'text-accent hover:text-accent-hover',
                identityPreviewText: 'text-text-primary',
                identityPreviewEditButton: 'text-accent',
                formFieldInputShowPasswordButton: 'text-text-muted',
                otpCodeFieldInput: 'bg-bg-tertiary border-border text-text-primary',
              },
              variables: {
                colorPrimary: '#6366f1',
                colorBackground: '#1a1b1e',
                colorInputBackground: '#25262b',
                colorInputText: '#e5e7eb',
                colorText: '#e5e7eb',
                colorTextSecondary: '#9ca3af',
                borderRadius: '0.5rem',
              },
            }}
            routing="path"
            path="/login"
            signUpUrl="/login"
          />
        </div>

        <p className="text-center text-text-muted text-xs mt-6">
          Secure authentication powered by Clerk
        </p>
      </motion.div>
    </div>
  );
}
